module.exports = {
  designationCode: 'central-valley',
  plugins: {
    hq: {
      contact_info: {
        contact_us_href: 'https://www.centralvalleymeat.com/contact-us/',
        site_corner_image: '/static/CVCLoads-2.png',
      },
    },
    locality: {
      lang: 'en',
      country: 'US',
      locale: 'en-US',
      load_map: {
        center: {
          lat: 36.330047,
          lng: -119.492545,
        },
      },
      is_cvc_loads: true,
    },
    loadboard: {
      enabled: true,
      states: [],
      enableBidding: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/api/siteDesignations/central-valley.js